/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesPlayGameIframeGameConfigOptions
 */
export interface FxIdWebFeaturesPlayGameIframeGameConfigOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesPlayGameIframeGameConfigOptions
     */
    IframeUrl: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesPlayGameIframeGameConfigOptions interface.
 */
export function instanceOfFxIdWebFeaturesPlayGameIframeGameConfigOptions(value: object): value is FxIdWebFeaturesPlayGameIframeGameConfigOptions {
    if (!('IframeUrl' in value) || value['IframeUrl'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesPlayGameIframeGameConfigOptionsFromJSON(json: any): FxIdWebFeaturesPlayGameIframeGameConfigOptions {
    return FxIdWebFeaturesPlayGameIframeGameConfigOptionsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameIframeGameConfigOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayGameIframeGameConfigOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'IframeUrl': json['IframeUrl'],
    };
}

export function FxIdWebFeaturesPlayGameIframeGameConfigOptionsToJSON(json: any): FxIdWebFeaturesPlayGameIframeGameConfigOptions {
    return FxIdWebFeaturesPlayGameIframeGameConfigOptionsToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameIframeGameConfigOptionsToJSONTyped(value?: FxIdWebFeaturesPlayGameIframeGameConfigOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'IframeUrl': value['IframeUrl'],
    };
}

